/* eslint-disable */
import 'jquery.cookie';

import '@/js/desktop/globalIncludes';
import '@/js/desktop/globalComponents';

import '@/css/desktop/search';
import '@/css/desktop/search/destination-info-atlas.css';
import './css/atlas-header-withMenu.scss';
import './css/atlas-page-sections.css';
import './css/atlas-hotels-map.css';

import AbstractSearchController from '@/js/desktop/Domain/Abstract/SearchController';
import tourCriteriaService from "@/js/common/Domain/Service/tourCriteria";
import SocialButtons from "@/js/desktop/components/social-btns";

let Controller = AbstractSearchController.extend({
	initSocialButtons() {
		new SocialButtons({
			el: '.social-btns'
		});
	},
	initialize: function() {
		$.removeCookie('requestFromMainPage', {path: '/', domain: 'all'});
		tourCriteriaService.clearTourCriteriaChangedFields();

		AbstractSearchController.prototype.initialize.call(this);
		this.view.model.set('viewMode', 'map');
		this.initSocialButtons();
	}
});

$(() => {
	new Controller({
		el: 'body'
	});
});

